import { render, staticRenderFns } from "./cq-how-to-play.vue?vue&type=template&id=395ade17&scoped=true&"
import script from "./cq-how-to-play.vue?vue&type=script&lang=js&"
export * from "./cq-how-to-play.vue?vue&type=script&lang=js&"
import style0 from "./cq-how-to-play.vue?vue&type=style&index=0&id=395ade17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395ade17",
  null
  
)

export default component.exports